import { Helmet } from "react-helmet-async";

export default function FitterAIAccountDeletion() {
  return (
    <div className="min-h-screen bg-[#FBFAF6] text-[#26313B] p-8 md:p-16 transition-colors duration-300">
      <Helmet>
        <title>Account Deletion – FitterAI</title>
        <meta
          name="description"
          content="How to delete your FitterAI account and associated data."
        />
        <link
          rel="canonical"
          href="https://cosmovexapps.com/apps/fitterai/account-deletion"
        />
      </Helmet>

      <h1 className="text-4xl font-bold mb-6 text-[#A8720E]">
        Account Deletion – FitterAI
      </h1>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-4xl">
        If you have a <strong>FitterAI</strong> account, you can request deletion
        of your account and all associated data at any time using either of the
        methods below.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        1. Delete from Within the App (Recommended)
      </h2>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-4xl">
        Open FitterAI → Settings → Account → <strong>Delete Account</strong>.
        You will be asked to confirm. Once confirmed, your account and data are
        permanently deleted immediately.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        2. Delete via Email
      </h2>

      <p className="text-[#3D4B59] leading-relaxed mb-4 max-w-4xl">
        Send an email to:
      </p>

      <p className="text-lg font-semibold text-[#0F6BBF] mb-4">
        <a
          href="mailto:support@cosmovex.com?subject=FitterAI%20Account%20Deletion"
          className="underline hover:text-[#0C5AA3]"
        >
          support@cosmovex.com
        </a>
      </p>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-4xl">
        Include &ldquo;FitterAI Account Deletion&rdquo; in the subject line and
        send from the email address associated with your FitterAI account so we
        can verify ownership.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        3. What Gets Deleted
      </h2>

      <ul className="list-disc list-inside text-[#3D4B59] leading-relaxed space-y-2 max-w-4xl">
        <li>Firebase Authentication account and sign-in credentials.</li>
        <li>All Cloud Firestore data: profile, workout logs, plans, streak, nutrition entries, body weight logs.</li>
        <li>Progress photos stored in your account.</li>
        <li>Firebase Cloud Messaging tokens (push notification tokens).</li>
        <li>Referral and challenge data associated with your account.</li>
        <li>Subscription entitlement records on our servers.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        4. What Does NOT Auto-Delete
      </h2>

      <ul className="list-disc list-inside text-[#3D4B59] leading-relaxed space-y-2 max-w-4xl">
        <li>
          <strong>Active subscriptions:</strong> deleting your account does not
          cancel your App Store or Google Play subscription. You must cancel your
          subscription in your device&apos;s store settings before deleting your
          account to avoid continued charges.
        </li>
        <li>
          <strong>Locally cached data:</strong> workout data cached on your device
          via Hive local storage remains until you uninstall the app or clear app
          data.
        </li>
        <li>
          Records we may need to retain for legal, fraud prevention, or accounting
          purposes.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        5. Processing Time
      </h2>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-4xl">
        <strong>In-app deletion:</strong> immediate.
        <br />
        <strong>Email requests:</strong> processed within 7 business days after
        ownership verification.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">6. Contact</h2>

      <p className="text-[#3D4B59] leading-relaxed max-w-4xl">
        For questions about account deletion or your data, contact{" "}
        <a
          href="mailto:support@cosmovex.com"
          className="text-[#0F6BBF] underline hover:text-[#0C5AA3]"
        >
          support@cosmovex.com
        </a>
        .
      </p>

      <p className="text-[#8A93A2] mt-10">
        Last updated: March 19, 2026
      </p>
    </div>
  );
}
